import { Auth } from "aws-amplify"
import axios from "axios"
import { mysphereAPIURL } from "../app/auth/util/CustomConstants";

// Function Helpers
const triggerRevokedSessionLogout = () => {
  const logoutPath = (process.env.PUBLIC_URL || "") + "/logout";

  if (typeof window !== "undefined" && window.location.pathname !== logoutPath) {
    window.location.assign(logoutPath);
  }
};

const getOrRefreshGoogleAccessToken = async (token) => {
    try {
        const headers = {
            "Content-Type": "application/json",
        };

        const response = await axios.post(
            `${mysphereAPIURL}/api/v1/user/token/google/refresh`,
            { jwtToken: token },
            { headers }
        )

        if (response.status === 200 && response.data && response.data.token) { 
            // console.log("Response Data", response.data)

            // if the token was refreshed, update the local storage with the new token
            // subsequent calls to getOrRefreshGoogleAccessToken will use the refreshed token
            if (response.data.refreshed) {
                let googleAuth = JSON.parse(localStorage.getItem("googleAuth"))
                googleAuth.token = response.data.token
                localStorage.setItem("googleAuth", JSON.stringify(googleAuth))
            }

            return response.data.token
        } else {
            return null
        }
    } catch (error) {
        // Refresh token is revoked or invalid, trigger logout
        const isRevoked = error?.response?.status === 400 && error?.response?.data?.isRevoked === true;

        if (isRevoked) {
            triggerRevokedSessionLogout();
        }

        return null;
    }
}

export const getAccessToken = async () => {
    try{
        let accessToken = null;

        const googleAuth = JSON.parse(localStorage.getItem("googleAuth"))
        if(googleAuth && 'token' in googleAuth && 'email' in googleAuth) {
            accessToken = await getOrRefreshGoogleAccessToken(googleAuth.token)
        } else {
            const auth = await Auth.currentSession();
            accessToken = auth.accessToken.jwtToken;
        }

        return accessToken;
    }catch(e){
        console.error("Error getting access token: ", e);
        return null
    }
}